import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Chapters } from "../components/Chapters";
import { Interlude } from "../components/Interlude";
import { Services } from "../components/Services";
import { Conditions } from "../components/Conditions";
import { Faq } from "../components/Faq";
import { Memberships } from "../components/Memberships";
import { Testimonials } from "../components/Testimonials";
import { Locations } from "../components/Locations";
import { Footer } from "../components/Footer";
import { StickyCTA } from "../components/StickyCTA";

export default function Home() {
  return (
    <div className="grain bg-[#FAF8F3] text-stone-800 min-h-screen" data-testid="app-root">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Chapters />
        <Services />
        <Interlude />
        <Conditions />
        <Faq />
        <Memberships />
        <Testimonials />
        <Locations />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
